import React, { Fragment, useState, useEffect } from 'react'

import S from './Offcanvas.styled'
import { useHeaderContext } from '../../HeaderContext'
import ListItem from './list/ListItem'
import ListDropdown from './list/ListDropdown'
import links from '../../../../config/header/menu'
import { toggleBodyClass, matchPath } from '../../utils'

const Offcanvas = () => {
  const {
    menu: { browse, community, genres },
    games,
  } = links
  const { isOpen, toggle, lightMode } = useHeaderContext()
  const [activeLink, setActiveLink] = useState(null)

  useEffect(() => {
    const link = matchPath(community)
    if (link) setActiveLink(link.id)
  }, [activeLink])

  const onLinkClick = () => {
    toggle()
    toggleBodyClass()
  }

  return (
    <S.Offcanvas menuIsOpen={isOpen} lightMode={lightMode}>
      <nav>
        <div className="section">
          <span className="title">Browse</span>
          <ul className="menu">
            {browse.map((props) => (
              <ListItem
                key={props.title}
                onLinkClick={onLinkClick}
                {...props}
              />
            ))}
            <ListDropdown
              title="Genres"
              data={genres}
              onLinkClick={onLinkClick}
            />
          </ul>
        </div>
        <div className="section">
          <ul className="menu">
            {community.map((props) => (
              <Fragment key={props.title}>
                <ListItem
                  onLinkClick={onLinkClick}
                  activeLink={props.id === activeLink && true}
                  {...props}
                />

                {props.id === 'news' && (
                  <ListDropdown
                    title="Games"
                    data={games}
                    onLinkClick={onLinkClick}
                  />
                )}
              </Fragment>
            ))}
          </ul>
        </div>
      </nav>
    </S.Offcanvas>
  )
}

export default Offcanvas
